module.exports = __webpack_public_path__ + "static/media/play.3fd9881a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video/play.svg
// module id = 587
// module chunks = 0